<script setup lang="ts">
import {BatteryCharging, Droplets, ShieldCheck, Sparkles} from "lucide-vue-next";

const productAreas = [
  {
    icon: Droplets,
    title: "Öle & Flüssigkeiten",
    text: "Motoröl, Bremsflüssigkeit, Kühlmittel und passende Pflege für Ihr Fahrzeug."
  },
  {
    icon: BatteryCharging,
    title: "Batterien & Verschleißteile",
    text: "Sinnvolle Ersatzteile mit Beratung, damit Qualität und Fahrzeug zusammenpassen."
  },
  {
    icon: Sparkles,
    title: "Pflege & Zubehör",
    text: "Praktisches Zubehör für Werterhalt, Innenraum, Winterbetrieb und Alltag."
  },
  {
    icon: ShieldCheck,
    title: "Beratung vor Ort",
    text: "Wir empfehlen nur Produkte, die technisch sinnvoll und wirtschaftlich fair sind."
  }
];
</script>

<template>
  <main class="products-page">
    <section class="products-hero">
      <h1>Produkte & Zubehör</h1>
      <p>Alles rund ums Fahrzeug: sinnvoll ausgewählt, passend beraten und direkt mit Werkstatt-Know-how empfohlen.</p>
    </section>

    <section class="products-grid">
      <article class="product-card" v-for="area in productAreas" :key="area.title">
        <component :is="area.icon" class="product-icon"/>
        <h2>{{ area.title }}</h2>
        <p>{{ area.text }}</p>
      </article>
    </section>
  </main>
</template>

<style scoped>
.products-page {
  width: min(1400px, calc(100% - 2rem));
  margin: 2rem auto 4rem;
}

.products-hero {
  padding: clamp(3rem, 7vw, 5rem) clamp(1.25rem, 4vw, 3rem);
  color: #ffffff;
  text-align: center;
  border-radius: 18px;
  background:
      radial-gradient(circle at 18% 22%, rgba(96, 165, 250, 0.36), transparent 22rem),
      linear-gradient(135deg, #0f172a 0%, #1e3a8a 56%, #2563eb 100%);
  box-shadow: var(--shadow-strong, 0 24px 60px rgba(15, 23, 42, 0.16));
  animation: pageRise 0.55s ease both;
}

.products-hero h1 {
  margin: 0 0 0.8rem;
  font-size: clamp(2.25rem, 5vw, 4rem);
  line-height: 1.05;
}

.products-hero p {
  max-width: 760px;
  margin: 0 auto;
  color: rgba(255, 255, 255, 0.86);
  font-size: 1.15rem;
  line-height: 1.7;
}

.products-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 1.25rem;
}

.product-card {
  padding: 2rem;
  background: #ffffff;
  border: 1px solid var(--line, rgba(15, 23, 42, 0.1));
  border-radius: var(--radius, 14px);
  box-shadow: var(--shadow, 0 16px 38px rgba(15, 23, 42, 0.1));
  transition: transform 0.25s ease, box-shadow 0.25s ease, border-color 0.25s ease;
}

.product-card:hover {
  transform: translateY(-6px);
  border-color: rgba(37, 99, 235, 0.22);
  box-shadow: var(--shadow-strong, 0 24px 60px rgba(15, 23, 42, 0.16));
}

.product-icon {
  width: 48px;
  height: 48px;
  padding: 0.6rem;
  border-radius: 14px;
  color: var(--brand-blue, #2563eb);
  background: var(--brand-blue-soft, rgba(37, 99, 235, 0.1));
}

.product-card h2 {
  color: var(--ink, #0f172a);
}

.product-card p {
  color: var(--muted, #475569);
  line-height: 1.7;
}

</style>
